module.exports = __webpack_public_path__ + "static/media/avatar-4.814616b0.jpg";